export default "https://cdn-static.gokick.com/assets/10f8238ac2c3e70096f19214fcd9b55856558067/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";